@if (!config['visibilityFn'] || config['visibilityFn'](config.value)) {
  <div class="w-full flex justify-start items-center space-x-4">
    @if (config.thumbnailConfig && (config.thumbnailConfig.backgroundColorClasses || config['profileColor']) && !(config.thumbnailSource | toString)) {
      <div
        class="w-8 h-8 shrink-0 grow-0 rounded-lg flex justify-center items-center"
        [ngClass]="config.thumbnailConfig.backgroundColorClasses && config.thumbnailConfig.backgroundColorClasses.length > 0 ? (config.thumbnailConfig.backgroundColorClasses | drawItem:(index ?? 0) | toString) : 'bg-cyan'"
        [style.background-color]="config['profileColor'] || null"
      >
        <span class="uppercase">
          {{ config.value | toString | firstCharOfWords }}
        </span>
      </div>
    }

    @if (config.mimetype && config.thumbnailSource) {
      <div class="w-8 h-8 flex justify-center items-center relative">
        <nrc-media-preview
          class="w-full h-full top-0 left-0 rounded-lg overflow-hidden"
          [mimetype]="config.mimetype"
          [source]="config.thumbnailSource | toString"
          [mediaPreviewTypes]="['image']"
          [classList]="'bg-[#fefefe1a] shadow-[0px 6px 14px #00000033] border-2 border-solid border-white/10 rounded-10'"
        />
      </div>
    }

    <div class="flex flex-col max-w-fit overflow-auto h-8">
      <span class="tracking-wide text-ellipsis overflow-hidden whitespace-nowrap text-xs"
        [ngClass]="{
          'text-[#898989] font-light': !config.isHighlighted,
          'text-[#fafafa] font-semibold': config.isHighlighted && !isSelected,
          'text-cyan font-semibold': config.isHighlighted && isSelected,
        }"
      >{{ config.value }}</span>

      @if (config.additionalInfo) {
        <span class="text-[#898989] text-xs font-light tracking-wide">
          {{ config.additionalInfo | toString }}
        </span>
      }
    </div>
  </div>
}
